import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StripeCardSavedEvent } from './stripe-add-card.component';

/** Drop-in trigger for the Stripe card form: renders a single button that pops the card form
 *  (`app-stripe-add-card`) in a modal, so any page in the app can add "add a card" with one tag —
 *  `<app-stripe-add-card-button></app-stripe-add-card-button>` — without owning any dialog state
 *  itself. `label` lets each usage site word the button for its own context. */
@Component({
  selector: 'app-stripe-add-card-button',
  templateUrl: './stripe-add-card-button.component.html',
  styleUrls: ['./stripe-add-card-button.component.scss']
})
export class StripeAddCardButtonComponent {
  @Input() label = 'Add card';
  @Output() cardSaved = new EventEmitter<StripeCardSavedEvent>();

  dialogVisible = false;

  open(): void {
    this.dialogVisible = true;
  }

  close(): void {
    this.dialogVisible = false;
  }

  onCardSaved(event: StripeCardSavedEvent): void {
    this.cardSaved.emit(event);
    this.close();
  }
}
